import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TextInputDataComponent } from '../../../components/text-input/text-input.component';
import { SelectComponent } from '../../../components/select/select.component';
import { HandleBookingService } from '../../../services/handle-booking.service';
import { RadioBtnComponent } from '../../../components/radio-btn/radio-btn.component';
import { ParkingRepo } from '../../../repo/parking.repo';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmModalComponent } from '../../../components/confirm-modal/confirm-modal.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { EmailInputFieldComponent } from '../../../components/email-input-field/email-input-field.component';
import { PhoneNumberInputComponent } from '../../../components/phone-number-input/phone-number-input.component';
import { CommonModule } from '@angular/common';
import { FormService } from '../../../organizations/features/booking/components/form/service';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmServiceCancelComponent } from '../../../components/modal-confirm-service-cancel/modal-confirm-service-cancel.component';
import { BookingSummaryCardComponent } from '../../../components/booking-summary-card/booking-summary-card.component';
import { BookingConfigService } from '../../../services/booking-config.service';
import { FormGroup } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { BackOfficeService } from '../../../../services/backoffice.service';
import { SelfServiceService } from '../../../../services/self-service.service';
import { DateTime } from 'luxon';
import { CheckoutServices } from '../../../services/checkout.service';
import { timeout } from 'rxjs/internal/operators/timeout';
import { catchError } from 'rxjs';
import { CartService } from '../../../../../app/services/cart.service';
import { formatTerminalLocationForDate } from '../../../../models/BookingModel';
import { TranslateAttributePipe } from '../../../../pipes/translate-attribute/translate-attribute.pipe';

@Component({
  selector: 'app-booking-overview',
  imports: [
    RouterLink,
    TextInputDataComponent,
    SelectComponent,
    RadioBtnComponent,
    TranslocoModule,
    EmailInputFieldComponent,
    PhoneNumberInputComponent,
    CommonModule,
    BookingSummaryCardComponent,
    MatProgressBarModule,
    MatListModule,
    MatIconModule,
    TranslateAttributePipe
  ],
  templateUrl: './booking-overview.component.html',
  styleUrl: './booking-overview.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [HandleBookingService]
})

export class BookingOverviewComponent {
  handleBookingStatus: 'error' | 'updated' | '' = '';
  handleBookingGroup: any;
  email: string | null = "";
  bookingNumber: string | null = "";
  arrivalParkingOptions = [
    { value: '', viewValue: '' },
  ];
  parkingFrom: any;
  site: string = ""
  booking: any = null;
  checkInBagage: any = []
  additionalServices: any;
  orderId: any = null;
  passengers = [
    { value: '1', viewValue: '1' },
    { value: '2', viewValue: '2' },
    { value: '3', viewValue: '3' },
    { value: '4', viewValue: '4' },
    { value: '5', viewValue: '5' },
    { value: '6', viewValue: '6' },
    { value: '7', viewValue: '7' },
    { value: '8', viewValue: '8' },
  ]
  parkType: string = '';
  freeShuttles: boolean = false;
  bookingDetails: any = {
    order: null,
    parking: null,
    shuttles: [],
    additionalServices: []
  };
  form !: FormService;
  parkingType!: string;
  details !: FormGroup;
  parkingGroup: any;
  departureHotel: any;
  arrivalHotel: any;
  bookingLoaded: boolean = false;
  activeLang: string = 'sv';
  officeAddress: string = 'Matchedin AB, org.nr: 559013-7716 Wallingatan 42, 111 24 Stockholm';
  isLoading: boolean = false;
  parkingNames: any = {
    "677844ae-bb01-4265-bfde-32264410ed09": 'P_49',
    "453f945a-ee11-4d75-8265-b16f00e5f04b": 'P_41',
    "f9e5d6c3-4419-4c61-a290-b16f00e5e500": 'P_40',
    "8c98315a-b2ad-4e70-86f9-5d54992fed26": 'P_39',
    "697844ae-bb01-4265-bfde-32264410ed09": 'P_67',
    "c797769e-66bf-4283-96c5-b16f00e5e126": 'P_1',
    "eacc8615-81a4-4013-a7e5-b16f00e5e270": 'P_6',
    "1a8879f4-a294-455b-97eb-b16f00e5e30a": 'P_12',
    "5d2c7728-6944-45a6-a64e-b16f00e5e3b3": 'P_18',
    "8d922482-7855-47dc-953b-b16f00e5e45a": 'P_24'
  }
  organizationId: string = 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';
  allAdditionalServices: any = [];
  isEditable: boolean = false;
  optionsConfig: any;
  showPickUpButton: boolean = false;
  pickUpDone: boolean = false;
  vingBundles = ["PSVING2VECKA", "PSVING4VECKA", "PSVING3VECKA", "PSVING1VECKA", "PSVING"]
  hideCancelButton: boolean = false;
  showSubscription: boolean = false;
  isParkingPermitUser: boolean = false;
  additionalServicesAvailable: any[] = [];
  parkings: any;
  isLoadingParkings: boolean = false;
  hasSpecialParams: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private handleBookingService: HandleBookingService,
    private parkingRepo: ParkingRepo,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private translocoService: TranslocoService,
    private bookingConfigService: BookingConfigService,
    private _formService: FormService,
    public backofficeService: BackOfficeService,
    public translate: TranslocoService,
    public selfServiceService: SelfServiceService,
    private checkoutService: CheckoutServices,
    private cartService: CartService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    if ('options' in config) {
      const env: any = config;
      if ('confirmation' in env.options) {
        this.optionsConfig = env.options.confirmation;
      }
    }
  }

  openConfirmModal() {
    const text = this.booking?.parkingCannotBeCanceledText;
    const org = this.booking?.organizationName;
    const dialogRef = this.dialog.open(ConfirmModalComponent, { data: { text: text, org: org } });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cancelOrder();
      }
    });
  }

  // openModalConfirmServiceCancel() {
  //   const dialogRef = this.dialog.open(ModalConfirmServiceCancelComponent, {});
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.cancelServices();
  //     }
  //   });
  // }

  refreshBookingDetails() {
    this.handleBookingService.getBookingDetails(this.email!, this.bookingNumber!)
      .subscribe({
        next: (bookingDetails) => {
          this.booking.discountAmount = bookingDetails?.discountAmount;
          this.booking.discountPercent = bookingDetails?.discountPercent;
          this.booking.totalDiscountPriceIncVat = bookingDetails?.totalDiscountPriceIncVat;
          this.booking.totalPriceIncVat = bookingDetails?.totalPriceIncVat;
          this.booking.vatAmountDiscount = bookingDetails?.vatAmountDiscount;
          this.booking.totalVat = bookingDetails?.totalVat;
          this.booking.totalPriceExVat = bookingDetails?.totalPriceExVat;
        },
        error: (error) => {
          console.error("Failed to refresh booking after cancelling services:", error);
        }
      });
  }


  cancelOrder() {
    this.isLoading = true;
    this.handleBookingService.cancelByOrderNumberEmail(
      this.bookingNumber ? this.bookingNumber : '',
      this.email ? this.email : '',
    ).then((model) => {
      this.isLoading = false;
      if (model.result != "CanceledOrder") {
        const message = this.translate.translate('HANDLE_BOOKING.CANCEL_PARKING_FAILED');
        this._snackBar.open(message, 'OK',
          {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
      }
      if (model.result == "CanceledOrder") {
        const message = this.translate.translate('HANDLE_BOOKING.CANCEL_PARKING_SUCCESS');
        this._snackBar.open(message, 'OK', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.routerNavigatePreservingParams(['/parkifly/handle-booking']);
      }
    }).catch((error) => {
      this.isLoading = false;
      console.error(error);
    });
  }

  goToUpdateBooking() {
    this.routerNavigatePreservingParams(['parkifly', 'update-booking', { email: this.email, booking_number: this.bookingNumber }]);
  }

  goToEditParking() {
    this.routerNavigatePreservingParams(['parkifly', 'edit-parking', { email: this.email, booking_number: this.bookingNumber }]);
  }

  private getPreservedQueryParams(): Record<string, string> {
    const params = this.route.snapshot.queryParamMap;
    const queryParams: Record<string, string> = {};
    const lang = params.get('lang');
    const mobile = params.get('mobile');

    if (lang) {
      queryParams.lang = lang;
    }
    if (mobile) {
      queryParams.mobile = mobile;
    }

    this.hasSpecialParams = !!(lang || mobile);

    return queryParams;
  }

  private routerNavigatePreservingParams(commands: any[], extras: Record<string, any> = {}) {
    const preserved = this.getPreservedQueryParams();
    const mergedQueryParams = {
      ...(extras.queryParams || {}),
      ...preserved
    };

    if (Object.keys(mergedQueryParams).length > 0) {
      extras = { ...extras, queryParams: mergedQueryParams };
    }

    this.router.navigate(commands, extras);
  }

  public ngOnInit() {
    this.isLoading = true;
    this.getPreservedQueryParams();
    this.activeLang = this.translocoService.getActiveLang();
    this.translocoService.langChanges$.subscribe((lang) => {
      this.activeLang = lang;
    });
    this.translocoService.selectTranslate('PARKIFLY.PLACEHOLDER.1_HOUR_BEFORE')
      .subscribe(value => {
        this.checkInBagage = [
          { value: '1', viewValue: this.translocoService.translate("PARKIFLYFORM.YES") },
          { value: '0', viewValue: this.translocoService.translate("PARKIFLY.SUMMARY.ONLY_CARRYON_LUGGAGE_OPTION") },
        ]
      });

    this.route.paramMap.subscribe(params => {
      this.email = params.get("email");
      this.bookingNumber = params.get("booking_number");
      if (this.email && this.bookingNumber) {
        this.handleBookingService.getBookingDetails(this.email, this.bookingNumber).subscribe(
          {
            next: ((bookingDetails) => {

              if (bookingDetails?.orderStatus == "Checkout" || bookingDetails?.orderStatus == "CheckoutAdditional") {
                //scroll to payment section
                setTimeout(() => {
                  this.scrollToPayment();
                }, 1000);
              }

              this.site = bookingDetails.organizationName?.toLowerCase();
              if (this.site == "flygets.se") {
                this.site = "flygets";
              }
              if (this.site == "tui" || this.site == "nazar" || this.site == "ving") {
                this.site = "flygets";
              }
              if (this.site == "p2 utomhus") {
                this.isParkingPermitUser = true;
                this.site = "skavsta";
              }
              if (this.site == "quality hotel arlanda xpo parkering" || this.site == "quality-xpo-arlanda") {
                this.site = "quality";
              }
              if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.site = "aiden"
              }

              this.bookingConfigService.setOrganization(this.site);
              this.handleBookingService.initForm(this.site);
              this.handleBookingGroup = this.handleBookingService.getForm().get('details');
              this._formService.initForm(this.site);

              //pdf details
              this.parkingType = this._formService.selectedParking;
              this.form = this._formService;
              this.details = this.form.getForm().get('details');
              this.parkingGroup = this.form.getForm().get('parkingGroup');
              this.departureHotel = this.form.departureHotel || this.form.getForm().get('hotels')?.controls?.departureHotel?.value;
              this.arrivalHotel = this.form.arrivalHotel || this.form.getForm().get('hotels')?.controls?.arrivalHotel?.value;

              if (bookingDetails.orderStatus == "Cancelled") {
                const message = "#" + this.bookingNumber + " " + this.translate.translate('FLYGETS.SELFSERVICE.CANCELLED_ORDER');
                this._snackBar.open(message, 'OK', {
                  duration: 3000,
                  verticalPosition: 'top'
                });
                this.routerNavigatePreservingParams(['/parkifly/handle-booking']);
              }
              this.orderId = bookingDetails.orderId;
              this.booking = bookingDetails;
              this.showSubscription = (bookingDetails?.parkingProductType?.toLowerCase() == "subscription") ? true : false;
              if (this.site === "flygets") {
                this.checkAvailableParkings(this.booking.parkingFromActual, this.booking.parkingTo, this.booking.discountCode ?? 'NONE');
              }
              if (this.booking != null) {
                setTimeout(() => {
                  this.bookingLoaded = true;
                }, 1000);
              }

              this.handleBookingService.getForm().get('details').controls['cellular'].setValue(bookingDetails.cellular ?? '');
              this.handleBookingService.getForm().get('details').controls['regNr'].setValue(bookingDetails.carRegNumber ?? '');
              this.handleBookingService.getForm().get('details').controls['email'].setValue(bookingDetails.email ?? '');
              this.handleBookingService.getForm().get('details').controls['email'].disable();
              if (this.booking?.arrival?.terminalName == 'Terminal 5') {
                this.booking.arrival.terminalName = 'Terminal 4'
              }
              if (this.booking?.departure?.terminalName == 'Terminal 5') {
                this.booking.departure.terminalName = 'Terminal 4'
              }
              if (this.booking?.departure?.terminalName) {
                const depDate = this.booking?.parkingShuttleFrom || this.booking?.departure?.scheduledDeparture || this.booking?.parkingFromActual || this.booking?.parkingFrom;
                this.booking.departure.terminalName = formatTerminalLocationForDate(this.booking.departure.terminalName, depDate);
              }
              if (this.booking?.arrival?.terminalName) {
                const arrDate = this.booking?.parkingShuttleTo || this.booking?.arrival?.scheduledArrival || this.booking?.parkingTo;
                this.booking.arrival.terminalName = formatTerminalLocationForDate(this.booking.arrival.terminalName, arrDate);
              }
              if (this.site === 'skavsta' || this.site === 'quality hotel arlanda xpo parkering' || this.site === 'quality-xpo-arlanda' || this.site === 'quality' || this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {

                this.handleBookingService.getForm().get('details').controls['firstname'].setValue(bookingDetails.firstName ?? '');
                this.handleBookingService.getForm().get('details').controls['firstname'].disable();
                this.handleBookingService.getForm().get('details').controls['lastname'].setValue(bookingDetails.lastName ?? '');
                this.handleBookingService.getForm().get('details').controls['lastname'].disable();
                this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers?.toString());
                // this.booking.parkingShuttleFrom = bookingDetails.parkingFrom;
                // this.booking.parkingShuttleTo = bookingDetails.parkingTo;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
              }
              if (this.site === 'flygets') {
                this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
                this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFrom;
                this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
                this.parkingFrom = new Date(this.parkingFrom);
                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(currentParkingTime);

                const additionalServicesArray = bookingDetails?.additionalServices?.length > 0
                  ? bookingDetails.additionalServices.filter((e: any) => (e.status != 'Cancelled' && e.status != 'Removed'))
                  : [];
                if (additionalServicesArray.length > 0) {
                  additionalServicesArray.forEach(function (element: any, index: any) {
                    if (typeof element.name === 'string') {
                      element.name = JSON.parse(element.name);
                    }
                    if (typeof element.description === 'string') {
                      element.description = JSON.parse(element.description);
                    }
                    if (element.amount && element.vatAmount) {
                      element.amount = element.amount + element.vatAmount;
                    }
                  });
                }
                this.bookingDetails.additionalServices = additionalServicesArray;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
                // this.getAdditionalServices();
              }
              if (this.site === 'mdpark') {
                this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
                this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFrom;
                this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
                this.parkingFrom = new Date(this.parkingFrom);
                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(currentParkingTime);
              }
              this.isLoading = false;
            }),
            error: (error) => {
              this.isLoading = false;
              const message = this.translate.translate('FLYGETS.SELFSERVICE.VALIDATION_NOK');
              this._snackBar.open(message, 'OK', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              this.routerNavigatePreservingParams(['/parkifly/handle-booking']);
            }
          }
        );
      } else {
        this.routerNavigatePreservingParams(['/parkifly/handle-booking']);
      }
    });
  }

  checkAvailableParkings(periodFrom: string, periodTo: string, discountCode: string) {
    this.isLoadingParkings = true;
    // this.showRetryButton = false;
    // this.lastApiParams = { periodFrom, periodTo, discountCode };
    // const message = this.translocoService.translate('HANDLE_BOOKING.CHECK_AVAILABLE_PARKING');
    // this._snackBar.open(message, undefined, {
    //   duration: 3000,
    //   verticalPosition: 'top',
    //   horizontalPosition: 'center'
    // });
    this.cartService
      .getAvailableParkingsOnEdit(this.orderId, periodFrom, periodTo, discountCode)
      // .pipe(
      //   timeout(30000),
      //   catchError(error => {
      //     this.isLoadingParkings = false;
      //     setTimeout(() => {
      //       this.showRetryButton = true;
      //     }, 0);
      //     console.error('API call failed:', error);
      //     this.parkings = this.parkings || [];
      //     return of(null);
      //   })
      // )
      .subscribe((parkings: any) => {
        this.isLoadingParkings = false;
        // this.showRetryButton = false;
        // if (this.booking?.organizationName?.toLocaleLowerCase() == 'tui' || this.booking?.organizationName?.toLocaleLowerCase() == 'nazar') {
        //   this.parkings = parkings?.parkings.filter((parking: any) => {
        //     return parking.id == '8c98315a-b2ad-4e70-86f9-5d54992fed26';
        //   })
        // } else {
        this.parkings = parkings?.parkings?.reverse();
        // }

        const parkingSite: any = this.booking?.parking?.toLowerCase();
        const parking: any = parkings?.parkings?.filter((parking: any) => parking?.name?.toLowerCase() == parkingSite);
        this.additionalServicesAvailable = (parking && parking[0]?.additionalServices) || [];

      });
  }

  addOrderAdditionalService() {
    this.isEditable = true;
  }

  removeAdditionalService() {
    this.isEditable = false;
  }

  getAdditionalServices() {
    this.backofficeService
      .getOrganizationAdditionalServices(this.organizationId)
      .subscribe(allServices => {
        const bookedServices = this.bookingDetails.additionalServices || [];

        // Iterate through all additional services
        this.allAdditionalServices = allServices.map((service: any) => {

          if (typeof service.name === 'string') {
            service.name = JSON.parse(service.name);
          }

          const isPlanned = bookedServices.some(
            booked => booked.name?.sv === service.name?.sv
          );

          return {
            ...service,
            planned: isPlanned
          };
        });

        this.allAdditionalServices.sort((a, b) => {
          return (b.planned === true ? 1 : 0) - (a.planned === true ? 1 : 0);
        });
      });
  }

  onServiceSelectionChange(event: any) {
    const selectedServices = event.source.selectedOptions.selected.map(option => option.value);
    this.allAdditionalServices.forEach(service => {
      service.planned = selectedServices.includes(service);
    });
  }

  isOtherServiceActive(currentService: any): boolean {
    return this.allAdditionalServices.some(
      service =>
        service !== currentService &&
        service.name?.en !== 'Submission of key' &&
        service.planned
    );
  }

  goToPaymentPage() {
    this.routerNavigatePreservingParams(['parkifly', this.site, 'checkout', 'payment', this.orderId]);
  }

  scrollToPayment() {
    const message = "Please complete the payment.";
    this._snackBar.open(message, 'OK', {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
    const element = document.getElementById('payment-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  goToHandleBooking() {
    this.routerNavigatePreservingParams(['parkifly', 'handle-booking']);
  }

  goToAdditionalServices() {
    if (this.booking?.parkingStatus === 'Checkin') {
      this.dialog.open(ConfirmModalComponent, {
        data: {
          titleKey: 'HANDLE_BOOKING.CHECKIN_ADDITIONAL_SERVICES_TITLE',
          translationKey: 'HANDLE_BOOKING.CHECKIN_ADDITIONAL_SERVICES',
          infoOnly: true
        },
        width: '440px',
        maxWidth: 'calc(100vw - 32px)'
      });
      return;
    }

    if (this.email && this.bookingNumber) {
      this.routerNavigatePreservingParams(['parkifly/edit-parking-additional-services', { email: this.email, booking_number: this.bookingNumber }]);
    }
  }

  getSwedenTime(): DateTime {
    return DateTime.now().setZone('Europe/Stockholm');
  }

  isPickUpAvailable(): boolean {
    if (!this.booking || !this.booking.arrival) {
      return false;
    }

    if (this.booking.arrivalStatus?.toLowerCase() == "droppedoff" || this.booking.arrivalStatus?.toLowerCase() == "boarded") {
      return false;
    }

    const arrival = this.booking.arrival;

    // Case 1: Hotel-based booking (no flight arrivalCode)
    if (!arrival.arrivalCode) {

      const shuttleTimeStr = this.booking.parkingShuttleTo;
      if (!shuttleTimeStr) {
        return false;
      }
      const shuttleTime = DateTime.fromISO(shuttleTimeStr, { zone: 'utc' });
      const now = this.getSwedenTime();
      return now.toMillis() >= shuttleTime.toMillis();
    }

    // Case 2: Normal flight-based booking
    if (arrival.status?.toLowerCase() !== "landed") {
      return false;
    }

    const now = this.getSwedenTime();
    if ((arrival.baggage ?? 0) === 0) {
      const landedTimeStr = arrival.actualArrival;
      if (!landedTimeStr) {
        return false;
      }
      const landedTime = DateTime.fromISO(landedTimeStr, { zone: 'utc' });
      const diffMinutes = now.diff(landedTime, 'minutes').minutes;
      return diffMinutes >= 10;
    } else {
      if (arrival.firstBag) {
        const firstBagTime = DateTime.fromISO(arrival.firstBag, { zone: 'utc' });
        return now.toMillis() >= firstBagTime.toMillis();
      }
      return false;
    }
  }

  pickUp() {
    const payload = {
      orderId: this.orderId,
      shuttleId: this.booking.arrivalShuttleId,
      secret: "Pacing2024",
    };

    this.selfServiceService.pickMeUp(payload).then((res: any) => {
      if (res.result === "PickMeUpDone") {
        this.pickUpDone = true;
      }
    });
  }

  downloadPdf() {
    this.checkoutService.downloadReceipt(this.orderId).subscribe(blob => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'receipt.pdf';
      a.click();
    });
  }

  getDepartureTerminalName(): string {
    const term = this.booking?.departure?.terminalName;
    const date = this.booking?.parkingShuttleFrom || this.booking?.departure?.scheduledDeparture || this.booking?.parkingFromActual || this.booking?.parkingFrom;
    return formatTerminalLocationForDate(term, date);
  }

  getArrivalTerminalName(): string {
    const term = this.booking?.arrival?.terminalName;
    const date = this.booking?.parkingShuttleTo || this.booking?.arrival?.scheduledArrival || this.booking?.parkingTo;
    return formatTerminalLocationForDate(term, date);
  }

}
